import Header from './Header';
import Footer from './Footer';
import ChatWidget from '../ChatWidget';

const Layout = ({ children, hideFooter = false }) => {
  return (
    <div className="min-h-screen flex flex-col bg-[#F9F9F7]">
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      {!hideFooter && <Footer />}
      <ChatWidget />
    </div>
  );
};

export default Layout;
